import React from "react";
import RadioButton from "./RadioButton";

const RadioGroup = ({
  name,
  value,
  onChange,
  options = [],
  className,
  optionClassName,
}) => (
  <div className={className}>
    {options.map(({ value: optionValue, label }) => (
      <RadioButton
        key={optionValue}
        name={name}
        value={optionValue}
        checked={value === optionValue}
        onChange={onChange}
        label={label}
        className={optionClassName}
      />
    ))}
  </div>
);

export default RadioGroup;
